<script>
import { mapActions } from "vuex";

import API from "@/api";

import Modal from "@/components/_Shared/Modal/Index";
import Title from "@/components/_Shared/Title";

export default {
  components: {
    Modal,
    Title
  },

  props: {
    id: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    brand: {
      type: String,
      required: true
    },
    brandName: {
      type: String,
      required: true
    },
    first6: {
      type: String,
      required: true
    },
    last4: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      preloader: false
    };
  },

  methods: {
    ...mapActions("toast", ["setErrorToast", "setSuccessToast"]),

    async handleCreditCardDelete() {
      try {
        this.preloader = true;

        await API.CreditCards.clear(this.id);

        this.setSuccessToast("Cartão removido com sucesso!");

        this.$emit("updateCard");
      } catch (e) {
        this.setErrorToast(
          "Ocorreu um erro ao removermos o cartão. Tente novamente e caso o erro persista entre em contato com o nosso suporte."
        );
      }

      this.preloader = false;
    }
  }
};
</script>

<template>
  <Modal>
    <template slot="header">
      <Title title="Remover cartão de crédito" />
    </template>

    <template slot="body">
      <div class="card-info">
        <img :src="`/static/credit-card/${icon}.svg`" alt="Bandeira cc" />

        <div class="numbers">
          {{ first6.slice(0, 4) + ' ' + first6.slice(4, 6) }} <b>·· ····</b>  {{ last4 }}
        </div>
      </div>
    </template>

    <template slot="footer">
      <button
        class="btn bg-purple"
        :disabled="preloader"
        :class="{'btn--loading': preloader}"
        @click="handleCreditCardDelete"
      >
        <span>Excluir cartão</span>
      </button>

      <button
        class="btn btn-outlined"
        :disabled="preloader"
        :class="{'btn--loading': preloader}"
        @click="$emit('exit')"
      >
        <span>Voltar</span>
      </button>
    </template>
  </Modal>
</template>

<style scoped>
.card-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
img {
  width: 40px;
  height: 40px;
  margin-right: 4px;
}

.numbers {
  font-weight: 400;
  font-size: 14px;
}

.btn-outlined {
  padding: 8px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CreditCards/components/Remove.vue